import {
  PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME,
} from 'features/pii/const';
import { getAddressStreetType } from 'features/pii/func';
import { Fade } from 'helpers/animation';
import useFormInput from 'hooks/form/useFormInput';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import styled from 'styled-components';
import { paragraph500Mixin, scrollbarThumbMixin } from 'styles';
import FormInputAddressFinderValidation from '../FormInputAddressFinderValidation';

const CustomAddressFinderDropdown = ({
  field,
  information,
  setInformation,
  validation,
  setValidation,
}) => {
  const [addressSuggestion, setAddressSuggestion] = useState(null);

  const { setInformationFormInput, setValidationFormInput } =
    useFormInput(field);

  const handleDropdownItemSelected = (e, address) => {
    e.preventDefault();

    const {
      fullAddress,
      buildingName,
      subdwelling,
      streetNumber,
      streetName,
      streetType,
      locality,
      state,
      postcode,
    } = address;

    let newInformation = setInformationFormInput({
      value: fullAddress,
      information,
      setInformation,
    });
    newInformation = {
      ...newInformation,
      [PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME]: buildingName
        ? `${buildingName} ${subdwelling}`
        : subdwelling,
      [PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_NAME]: streetNumber,
      [PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_NAME]: streetName,
      [PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_NAME]:
        getAddressStreetType(streetType),
      [PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_NAME]: postcode,
      [PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_NAME]: locality,
      [PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_NAME]: state,
      [PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME]: false,
    };
    setInformation(newInformation);

    setValidationFormInput({
      validation,
      setValidation,
      isReset: true,
    });

    setAddressSuggestion(null);
  };

  const renderAddressSuggestionDropdown = () => {
    if (isEmpty(addressSuggestion)) return null;
    return (
      <DropdownMenu show={true}>
        {addressSuggestion?.map((address, index) => (
          <DropdownItem
            key={address.id}
            eventKey={index + 1}
            onClick={(e) => handleDropdownItemSelected(e, address)}
          >
            {address.fullAddress}
          </DropdownItem>
        ))}
      </DropdownMenu>
    );
  };

  return (
    <CustomAddressFinderDropdownStyled>
      <FormInputAddressFinderValidation
        field={field}
        information={information}
        setInformation={setInformation}
        validation={validation}
        setValidation={setValidation}
        addressSuggestion={addressSuggestion}
        setAddressSuggestion={setAddressSuggestion}
      />
      {renderAddressSuggestionDropdown()}
    </CustomAddressFinderDropdownStyled>
  );
};

const CustomAddressFinderDropdownStyled = styled.div`
  position: relative;
  width: 100%;
  ${Fade};
`;
const DropdownMenu = styled(Dropdown.Menu)`
  padding: 0;
  border: none;
  box-shadow: var(--ds-bs-4);
  max-height: 160px;
  border-radius: 0.375rem;
  width: 100%;
  overflow: auto;
  background: var(--ds-c-white);
  inset: 0px auto auto 0px !important;
  transform: translate(0px, 72px) !important;

  ${scrollbarThumbMixin};
`;
const DropdownItem = styled(Dropdown.Item)`
  ${paragraph500Mixin};
  display: flex;
  align-items: center;
  padding: 10px;
  text-transform: uppercase;
  min-height: 40px;
  height: fit-content;
  white-space: break-spaces;
  background: var(--ds-c-white);

  a:first-child {
    border-radius: 0.375rem 0.375rem 0 0;
  }

  &:hover {
    background: var(--ds-c-grey-light);
  }

  &:active {
    color: var(--ds-c-grey-dark);
  }
`;

export default CustomAddressFinderDropdown;
